import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const EmployeeExpense = () => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "400px",
      height: "400px",

      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/getexpenseview?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res.expenseDetails);
          setAllData(res.expenseDetails);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.expenseTitle?.includes(filetrtext) ||
        item?.expenseAmount?.includes(filetrtext) ||
        item?.executiveName?.includes(filetrtext) ||
        item?.approvedByName?.includes(filetrtext) ||
        item?.expenseDate?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [selectedExpense, setSelectedExpense] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelectedExpense(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);
    let data = "";
    if (approvalStatus === "approve") {
      data = {
        expenseId: selectedExpense && selectedExpense.expenseId,
        approved: 1,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: 144,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "disapprove") {
      data = {
        expenseId: selectedExpense && selectedExpense.expenseId,
        approved: 2,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: 144,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "sendNextApprove") {
      data = {
        expenseId: selectedExpense && selectedExpense.expenseId,
        approved: 0,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: 144,
        nextlevel: 1,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    }

    //console.log(data);

    updateApprovalStatus(
      {
        url: "/api/addExpense/",
        method: "PUT",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
      }
    );
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    setSelectedData(data);
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Employee Expense{" "}
            </label>{" "}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Expense Date</th>
                            <th>Employee Name</th>
                            <th>Expense Title</th>
                            <th>Expense Amount</th>
                            <th>Approved by</th>
                            <th>Approval</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.expenseDate}</td>
                                <td>{x.executiveName}</td>
                                <td>{x.expenseTitle}</td>

                                <td>{x.expenseAmount}</td>
                                <td>{x.approvedByName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    // disabled={
                                    //   x.nextlevel == 1
                                    //     ? x.allowApproveUserId == loginUserId
                                    //       ? false
                                    //       : true
                                    //     : x.approved == 0
                                    //     ? false
                                    //     : true
                                    // }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Expense Approval"
        visible={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("approve");
            }}
          >
            Approve
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => {
              handleApprovalSubmit("disapprove");
            }}
            className="btn btn-sm btn-primary"
          >
            Disapprove
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("sendNextApprove");
            }}
          >
            Send Next Approve
          </button>
        </div>
      </AntModal>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <h4 className="card-title">Employee Expense Details</h4>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsModalOpen(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>
        {selectedData && (
          <div>
            <div className="row">
              <p className="col-md-6">
                Expense Date:
                {selectedData && selectedData.expenseDate}
              </p>
              <p className="col-md-6">
                Employee Name : {selectedData && selectedData.executiveName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Expense Title: {selectedData && selectedData.expenseTitle}
              </p>
              <p className="col-md-6">
                Expense Amount : {selectedData && selectedData.expenseAmount}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Approved By :{selectedData && selectedData.approvedByName}
              </p>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default EmployeeExpense;
